import React, { useState, useEffect } from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Svg20 as ArrowBack } from '@swiggy-private/dls-web-icons/dist/web/generic/arrowBack';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// styles
import styles from './OTPInput.module.scss';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import AsyncButton from '@/widgets/AsyncButton/AsyncButton';
// helpers
import { isDeleteOrBackspace, isValidOtpInput } from '@/helpers/utils';
import { inputFocus } from './helper';
const OtpInput = ({ onBack, onSubmit, errorText, onChange, onResendOtp, email, }) => {
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [loginEnabled, setLoginEnabled] = useState(false);
    useEffect(() => {
        if (otp.every((digit) => digit !== '')) {
            setLoginEnabled(true);
        }
        else {
            setLoginEnabled(false);
        }
    }, [otp]);
    const handleChange = (index, event) => {
        if (!isValidOtpInput(event.key))
            return;
        onChange();
        inputFocus(event);
        const newOtp = [...otp];
        if (isDeleteOrBackspace(event.key))
            newOtp[index] = '';
        else
            newOtp[index] = event.key;
        setOtp(newOtp);
    };
    const handleSubmit = () => onSubmit(otp.join(''));
    const otpInputClass = cx(styles.otpInput, {
        [styles.otpInputError]: errorText,
    });
    const handlePaste = (event) => {
        event.preventDefault();
        const pastedData = event.clipboardData.getData('text');
        if (pastedData.length !== 6 || isNaN(Number(pastedData)))
            return;
        const otpArray = pastedData.split('');
        setOtp(otpArray);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.headerContainer },
            React.createElement("div", null,
                React.createElement(GenericIcon, { Icon: ArrowBack, fillColor: DlsColorTokens.text_High_Emphasis, className: styles.backIcon, onClick: onBack })),
            React.createElement("div", null,
                React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.header }, "Please enter OTP"),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: styles.subHeader },
                    "Sent to ",
                    email))),
        React.createElement("form", { onPaste: handlePaste },
            React.createElement("div", { className: styles.otpContainer }, otp.map((digit, index) => (React.createElement("input", { key: index, name: `otp${index + 1}`, type: "text", autoComplete: "off", className: otpInputClass, value: digit, onKeyDown: (e) => handleChange(index, e), tabIndex: index, maxLength: 1 })))),
            errorText && (React.createElement("div", { className: styles.errorText },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Reg, customColor: {
                        light: tokens.colors.red1,
                        dark: tokens.colors.red1,
                    } }, errorText))),
            React.createElement("div", { className: styles.resendOtp },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.primary, onClick: () => onResendOtp(true) }, "Re-send OTP")),
            React.createElement(AsyncButton, { className: styles.loginButton, variant: "primary", onClick: handleSubmit, isDisabled: !loginEnabled }, "Login"))));
};
export default OtpInput;
